export default "__VITE_ASSET__DtlU6fB8__"